module.exports = __webpack_public_path__ + "static/media/Human_ZG5121_1440.b6e8b122.jpeg";